import React from 'react';
import { Stack, Text, Spinner, SpinnerSize, MessageBar, MessageBarType } from '@fluentui/react';
import { CloudRegular } from '@fluentui/react-icons';
import { useAdminAccess } from '../components/Auth/AuthProvider';
import { CloudDashboard } from '../components/CloudDashboard/CloudDashboard';

const CloudManagementPage: React.FC = () => {
  const { isAdmin, isAdminLoading } = useAdminAccess();

  // Show loading while checking admin status
  if (isAdminLoading) {
    return (
      <Stack horizontalAlign="center" verticalAlign="center" style={{ height: '100vh' }}>
        <Spinner size={SpinnerSize.large} label="Checking permissions..." />
      </Stack>
    );
  }

  // Show access denied if not admin
  if (!isAdmin) {
    return (
      <Stack horizontalAlign="center" verticalAlign="center" style={{ height: '100vh', padding: '20px' }}>
        <Stack tokens={{ childrenGap: 20 }} horizontalAlign="center">
          <CloudRegular style={{ fontSize: '48px', color: '#d13438' }} />
          <Text variant="xxLarge" style={{ fontWeight: 600 }}>Access Denied</Text>
          <Text variant="large" style={{ textAlign: 'center', maxWidth: '500px' }}>
            You don't have permission to access the Cloud Management features. 
            Please contact your administrator if you believe this is an error.
          </Text>
          <MessageBar messageBarType={MessageBarType.error}>
            Admin privileges are required to manage cloud resources and view Azure Advisor recommendations.
          </MessageBar>
        </Stack>
      </Stack>
    );
  }

  return <CloudDashboard />;
};

export default CloudManagementPage;
